<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="para"><a id="page_ii"></a>ALSO BY L. A. BANKS</p>
<p class="linespace"> </p>
<p class="hangindent-para">    <em>Minion<br/>The Awakening<br/>The Hunted<br/>The Bitten<br/>The Forbidden</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// abouttheauthor.vue?9b00cd52